import { render, staticRenderFns } from "./WelcomeTour.vue?vue&type=template&id=16b98b70&scoped=true&"
import script from "./WelcomeTour.vue?vue&type=script&lang=js&"
export * from "./WelcomeTour.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeTour.vue?vue&type=style&index=0&id=16b98b70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b98b70",
  null
  
)

export default component.exports